export const activityMandatoryFieldsDefaultValue = {
  LIVE: [
    'sports',
    'name',
    'description',
    'duration',
    'image',
    'type',
    'typicalAgeRange',
    'liveUrl',
  ],
  BIRTHDAY: [
    'sports',
    'name',
    'description',
    'duration',
    'image',
    'type',
    'location',
  ],
  DEFAULT: [
    'sports',
    'name',
    'description',
    'duration',
    'image',
    'type',
    'typicalAgeRange',
    'location',
  ],
};
